module.exports = __webpack_public_path__ + "media/images/packshot_image_background-a3be761d17dc2fdcfd1655d72377e9e2.png";